import { render, staticRenderFns } from "./GGAppHeader.vue?vue&type=template&id=10b119b4&"
import script from "./GGAppHeader.vue?vue&type=script&lang=js&"
export * from "./GGAppHeader.vue?vue&type=script&lang=js&"
import style0 from "./GGAppHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b119b4')) {
      api.createRecord('10b119b4', component.options)
    } else {
      api.reload('10b119b4', component.options)
    }
    module.hot.accept("./GGAppHeader.vue?vue&type=template&id=10b119b4&", function () {
      api.rerender('10b119b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Elements/GGAppHeader.vue"
export default component.exports